import React from 'react';
import { styled } from '@mui/material';
import { StepsBase } from './StepsBase';

export const StepsVertical = styled(StepsBase)(({ theme }) => ({
    marginRight: 80,
    justifyContent: 'unset',
    [theme.breakpoints.down('xs')]: {
        display: 'none',
    },
}));

export const StepsHorizontal = styled(StepsBase)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 1,
    display: 'none',
    [theme.breakpoints.down('xs')]: {
        display: 'none',
    },
}));

type ModalStepsProps = {
    currentStep: number;
    totalSteps: number;
    onStepClick?: (step: number) => void;
};

export const ModalSteps: React.FCC<ModalStepsProps> = ({
    currentStep,
    totalSteps,
    onStepClick,
}) => {
    const onClickHandler = (index: number) => {
        if (onStepClick) {
            onStepClick(index);
        }
    };
    return (
        <StepsVertical
            current={currentStep}
            onClick={onClickHandler}
            steps={totalSteps}
            variant="vertical"
        />
    );
};

export const ModalHorizontalSteps: React.FCC<ModalStepsProps> = ({
    currentStep,
    totalSteps,
    onStepClick,
}) => {
    const onClickHandler = (index: number) => {
        if (onStepClick) {
            onStepClick(index);
        }
    };
    return (
        <StepsHorizontal
            current={currentStep}
            onClick={onClickHandler}
            steps={totalSteps}
            variant="horizontal"
        />
    );
};
